<template>
    <div class="LoadingSpinner modal modal-on" v-if="!dataLoaded">
        <div class="LoadingSpinner-state">{{store.loadingLabel}}</div>
        <div class="LoadingSpinner-message">{{store.loadingMessage}}</div>
        <div class="custom-LoadingSpinner-spinner_loading LoadingSpinner-spinner LoadingSpinner-spinner_loading" v-if="store.loadingLabel.toLowerCase() === 'loading'"></div>
        <div class="LoadingSpinner-spinner LoadingSpinner-spinner_error" v-if="store.loadingMessage !== ''">
            <iconWarning />
        </div>
    </div>
</template>

<script>
    import store from '@/store';
    import iconWarning from '@/icons/warning.svg';

    export default {
        name: 'LoadingSpinner',
        components: {
            iconWarning
        },
        computed: {
            store: () => {
                return store.state;
            },
            dataLoaded() {
                return this.$store.state.loaded;
            }
        },
        data() {
            return {};
        }
    };
</script>
